export type UserActionFeedbackStatus = 'working' | 'success' | 'error' | 'info';

export interface UserActionFeedbackDetail {
  id: string;
  status: UserActionFeedbackStatus;
  title: string;
  detail?: string;
  dismissAfterMs?: number;
}

export const USER_ACTION_FEEDBACK_EVENT = 'aees:user-action-feedback';

let feedbackSequence = 0;

export const createUserActionId = (prefix = 'action') => (
  `${prefix}-${Date.now()}-${feedbackSequence += 1}`
);

export const announceUserAction = (detail: UserActionFeedbackDetail) => {
  if (typeof window === 'undefined') return;
  window.dispatchEvent(new CustomEvent<UserActionFeedbackDetail>(USER_ACTION_FEEDBACK_EVENT, { detail }));
};
